import React, { Component } from "react";
import { getCDNUrl, convertUnicode } from "../commons/CommonFunctions";
import dateUtil from "date-and-time";
import * as _ from "lodash";

export default class UnauthBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectVal: {
        startDate: "",
        endDate: "",
        title: "",
        status: "",
        coverImage: null,
        demolished: false,
        demolishedType: "",
        src: null,
        enabled: false,
        result: null,
        canChangeImage: false,
        crop: {
          aspectRatio: 0.5,
          rotation: -1.5707963268,
        },
      },
      isShow: false,
      userId: "",
    };
  }

  componentDidMount() {
    if (this.props.projectDetail) {
      let project = this.props.projectDetail;
      let startDate = "";
      let endDate = "NA";
      let title = "";
      let type = "";
      let coverImage = null;
      let resizedImages = null;
      let demolished = project.demolished;
      let demolishedType = project.demolishedType;
      let userId = "";
      let canChangeImage;
      let stageValue = "Completed";
      if (this.props.projectDetail && this.props.projectDetail.project) {
        let proj = this.props.projectDetail.project;
        title =
          proj.jobTitle ||
          proj.sessionTitle ||
          proj.assignmentTitle ||
          proj.jobTitle ||
          proj.title;
        let stage = project.stage;
        userId = project.userId;
        type =
          project.participationDetails &&
          project.participationDetails.secondaryEntityType;
        canChangeImage = project.canChangeImage;
        coverImage = proj.coverImage;
        resizedImages = project.project && project.project.resizedImages;
        startDate = dateUtil.format(new Date(project.startDate), "DD MMM YYYY");
        if (project.endDate > 0) {
          endDate = dateUtil.format(new Date(project.endDate), "DD MMM YYYY");
        }

        stageValue = stage.charAt(0).toUpperCase() + stage.slice(1);
      }

      this.setState({
        projectVal: {
          startDate,
          endDate,
          title,
          status: stageValue,
          coverImage,
          resizedImages,
          userId,
          type,
          demolished,
          demolishedType,
          canChangeImage,
        },
        userId: userId,
      });

      return {
        startDate,
        endDate,
        title,
        status: stageValue,
      };
    }
  }

  render() {
    console.log("start date", this.props.projectDetail);
    return (
      <div className="prdbannerwrap">
        <div className="profilebann">
          <img
            src={
              this.state.projectVal &&
              this.state.projectVal.coverImage &&
              !_.isNull(this.state.projectVal.coverImage)
                ? getCDNUrl(this.state.projectVal.coverImage)
                : !_.isUndefined(this.state.projectVal.coverImage)
                ? "https://cdn.dscovr.com/images/project-default.jpg"
                : null
            }
            id="preview"
          />
        </div>
        <div className="prdbanndesc">
          <h1 className="projttlh1">
            {/* {getProjectDetails().title}    */}
            {convertUnicode(this.state.projectVal.title)}
          </h1>
          {this.state.projectVal.demolished === false && (
            <div className="banndatewrap">
              <div>
                <span>Start Date</span> {this.state.projectVal.startDate}
                {/* {getProjectDetails().startDate} */}
              </div>
              <div>
                <span>End Date</span> {this.state.projectVal.endDate}
                {/* {getProjectDetails().endDate} */}
              </div>
              {this.state.projectVal.demolished === false && (
                <div className="pdbannstatus">
                  {this.state.projectVal.status}
                </div>
              )}
            </div>
          )}
          {this.state.projectVal.demolished === true && (
            <div className="banndatewrap">
              <div className="pdbannstatus cancel">
                {this.state.projectVal.status}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
